<template>
  <div>
   <lab-supply-frame-info-review v-if="sampleobject.isLabSuppliedFrame" :frame="sampleobject.labSuppliedFrame" :sampleobject="sampleobject"></lab-supply-frame-info-review>
   <frame-to-come-info-review  :sampleobject="sampleobject" v-else ></frame-to-come-info-review>
  </div>
</template>
<script>
import FrameToComeInfoReview from "@/components/order/frame/FrameToComeInfoReview";
import LabSupplyFrameInfoReview from "@/components/order/frame/LabSupplyFrameInfoReview";

export default {
  props: ["sampleobject", "program"],
  components: { FrameToComeInfoReview, LabSupplyFrameInfoReview }
};
</script>
<style>
.frame-review-section {
  margin-top: 15px;
}

.uncut-smalltext {
  font-size: 11pt;
}
</style>
